import { render, staticRenderFns } from "./social-share.vue?vue&type=template&id=487bedb6&scoped=true"
import script from "./social-share.vue?vue&type=script&setup=true&lang=js"
export * from "./social-share.vue?vue&type=script&setup=true&lang=js"
import style0 from "./social-share.vue?vue&type=style&index=0&id=487bedb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487bedb6",
  null
  
)

export default component.exports